
const redirect = (e) => {
    const url = e.currentTarget.querySelector('a').getAttribute('href');
    window.location.href = url;
}

function turnContainerToLink(containers)
{

    containers.forEach(card => {
        const elems = document.querySelectorAll(card);

        elems.forEach(elem => {
            elem.addEventListener('click', (e) => redirect(e));
        });
    });
}

export default function init() {
    turnContainerToLink([
        '.posts-list .card',
    ]);
}
